export function getSecureRel(
  target: string | undefined,
  rel: string | undefined,
) {
  if (target !== '_blank') return rel;

  const mergedRel = new Set([
    ...(rel ?? '').split(/\s+/).filter(Boolean),
    'noopener',
    'noreferrer',
  ]);
  return [...mergedRel].join(' ');
}
